import React, { useState, useRef, useEffect } from 'react';
import { Input } from '@/components/ui/inputs/input';
import { InputSelect } from '@/components/ui/inputs/input-select';
import { InputPassWord } from '@/components/ui/inputs/input-password';
import { InputTextarea } from '@/components/ui/inputs/input-textarea';
import InputRadio from '@/components/ui/inputs/input-radio';
import { useForm, Controller } from 'react-hook-form';
import { getSettingService, updateSettingService } from '@/services/SettingServices';
import validationErrors from '@/lib/validationErrors';
import { useSelector, useDispatch } from 'react-redux';
import PermissionCheck from '@/components/common/PermissionCheck';

const MailPage = () => {
    const selectRef = useRef(null);
    const {
        register,
        setValue,
        getValues,
        formState: { errors },
        handleSubmit,
        control,
        reset,
    } = useForm();
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const [isFormSumbmit, setIsFormSumbmit] = useState(false);
    const [mailEncryption, setMailEncryption] = useState('ssl');
    const filedList = ['mail_encryption', 'mail_from_email', 'mail_from_name', 'mail_host', 'mail_password', 'mail_port', 'mail_username'];

    useEffect(() => {
        setValue('mail_encryption', 'ssl');
        setMailEncryption('ssl');
        getDataByKey({
            key_list: filedList,
        });
    }, []);

    const handleChangeRadio = (event) => {
        if (event.target.name == 'mail_encryption') {
            setValue('mail_encryption', event.target.value);
            setMailEncryption(event.target.value);
        }
    };

    const formReset = async () => {
        try {
            var formData = getValues();
            for (const key in formData) {
                await setValue(key, '');
            }
            await reset();
        } catch (error) {
            console.error('Error in onReset:', error);
        }
    };

    const getDataByKey = (keyList) => {
        setIsLoading(true);
        dispatch(getSettingService(keyList))
            .then((res) => {
                var formData = res?.data?.data;
                for (const key in formData) {
                    if (formData.hasOwnProperty(key) && formData[key] != '') {
                        setValue(key, formData[key]);
                    } else {
                        setValue(key, '');
                    }
                    if (key == 'mail_encryption') {
                        setValue('mail_encryption', formData[key]);
                        setMailEncryption(formData[key]);
                    }
                }
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const onSubmit = (data) => {
        setIsFormSumbmit(true);
        dispatch(updateSettingService(data))
            .then((res) => {
                getDataByKey({
                    key_list: filedList,
                });
                setIsFormSumbmit(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsFormSumbmit(false);
            });
    };

    return (
        <div id="company" className="db-card db-tab-div active">
            <div className="db-card-header">
                <h3 className="db-card-title">Mail</h3>
            </div>
            <div className="db-card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="mail_host"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Mail Host'}
                                    type="text"
                                    id="mail_host"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.mail_host?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="mail_port"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Mail Port'}
                                    type="text"
                                    id="mail_port"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.mail_port?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="mail_username"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Mail Username'}
                                    type="text"
                                    id="mail_username"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.mail_username?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="mail_password"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Mail Password'}
                                    type="text"
                                    id="mail_password"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.mail_password?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="mail_from_name"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Mail From Name'}
                                    type="text"
                                    id="mail_from_name"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.mail_from_name?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="mail_from_email"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Mail From Email'}
                                    type="text"
                                    id="mail_from_email"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.mail_from_email?.type}
                                />
                            )}
                        />
                        <div className="form-input-item">
                            <label className="db-field-title required" htmlFor="active">
                                {'Mail Encryption'}
                            </label>
                            <div className="db-field-radio-group">
                                <InputRadio
                                    id="Yes"
                                    name="is_featured"
                                    labelText={'SSL'}
                                    value="ssl"
                                    onChange={() => handleChangeRadio({ target: { name: 'mail_encryption', value: 'ssl' } })}
                                    checked={mailEncryption == 'ssl' ? true : false}
                                />
                                <InputRadio
                                    id="tls"
                                    name="is_featured"
                                    labelText={'TLS'}
                                    value="tls"
                                    onChange={() => handleChangeRadio({ target: { name: 'mail_encryption', value: 'tls' } })}
                                    checked={mailEncryption == 'tls' ? true : false}
                                />
                            </div>
                        </div>
                        <PermissionCheck permsission={'update_settings'}>
                            <div className="sm:col-span-2">
                                <button type="submit" className="db-btn text-white bg-primary" disabled={isFormSumbmit || isLoading ? true : false}>
                                    <i className="lab lab-save"></i>
                                    <span>Save</span>
                                    {isFormSumbmit ? (
                                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    ) : (
                                        <></>
                                    )}
                                </button>
                            </div>
                        </PermissionCheck>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default MailPage;
